var app = angular.module('leonardo');

var SubCategoryName = function (SubCategoryRestService) {
  return function (subcategoryId) {
    if (!subcategoryId) return 'Not specified yet';
    var list = SubCategoryRestService.getCollection();
    var name = '';
    angular.forEach(list, function(item) {
      if (item.id == subcategoryId) name = item.name;
    });
    return name;
  }
};

app.filter('subcategoryName', ['SubCategoryRestService', SubCategoryName]);
